import { useContext, useEffect, useRef, useState } from "react";

import { api_without_cancellation } from "../../../../api/api";
import { CaseNavigatorModalContext } from "../../CaseNavigatorModalContext";
import { setEqualColumnWidthsCounty } from "../../../../Utils/helper";

const CountyTab = ({ caseTypes, currentFilter, rowCount, onCaseTypeAvailabilityChange }) => {
  const [CountiesList, setCountiesList] = useState([]);
  const [CaseCountiesVenueData, setCountiesVenueData] = useState([]);
  const [countyHeaderMode, setCountyHeaderMode] = useState("full");
  const { handleShowModal } = useContext(CaseNavigatorModalContext);
  // const fetchCountyVenueData = async (currentFilter2) => {
  //   const countyvenue_data = await api_without_cancellation.get(
  //     "/api/navigator/navigator_countyvenue_data/",
  //     currentFilter2
  //       ? {
  //           params: {
  //             [currentFilter2.type]: currentFilter2.name || "",
  //           },
  //         }
  //       : {}
  //   );

  //   setCountiesVenueData(countyvenue_data.data.case_county_venue_data);
  //   setCountiesList(countyvenue_data.data.county_list);
  // };

  const fetchCountyVenueData = async (currentFilter2) => {
    try {
      const res = await api_without_cancellation.get(
        "/api/navigator/navigator_countyvenue_data/",
        currentFilter2
          ? {
              params: {
                [currentFilter2.type]: currentFilter2.name || "",
              },
            }
          : {}
      );

      const data = res?.data?.case_county_venue_data ?? [];
      setCountiesVenueData(data);
      setCountiesList(res?.data?.county_list ?? []);
      onCaseTypeAvailabilityChange?.(
        new Set(
          data
            .filter((row) => row.some((item) => item.count > 0))
            .flatMap((row) => {
              const item = row[0];
              const keys = [];
              if (item?.case_type_id !== null && item?.case_type_id !== undefined) {
                keys.push(`id:${item.case_type_id}`);
              }
              if (item?.case_type) {
                keys.push(`name:${item.case_type.trim().toLowerCase()}`);
              }
              return keys;
            })
        )
      );
    } catch (error) {
      console.error("Failed to fetch county venue data:", error);
      setCountiesVenueData([]);
      setCountiesList([]);
      onCaseTypeAvailabilityChange?.(new Set());
    }
  };

  useEffect(() => {
    fetchCountyVenueData(currentFilter);
  }, [currentFilter]);

  // const getSpanText = (spanClass) => {
  //   switch (spanClass) {
  //     case "span_1_D":
  //       return "between 0 Day and 1 Day";
  //     case "span_2_D":
  //       return "between 1 Day and 2 Day";
  //     case "span_3_D":
  //       return "between 2 Day and 3 Day";
  //     case "span_1_Wk":
  //       return "between 3 Day and 1 Week";
  //     case "span_2_Wks":
  //       return "between 1 Week and 2 Weeks";
  //     case "span_1_Mo":
  //       return "between 2 Week and 1 Month";
  //     case "span_2_Mos":
  //       return "between 1 Month and 2 Months";
  //     case "span_3_Mos":
  //       return "between 2 Months and 3 Months";
  //     case "span_6_Mos":
  //       return "between 3 Months and 6 Months";
  //     case "span_1_Yr":
  //       return "between 6 Months and 1 Year";
  //     case "span_2_Yrs":
  //       return "between 1 Year and 2 Years";
  //     case "span_3_Yrs":
  //       return "between 2 Years and 3 Years";
  //     case "span_5_Yrs":
  //       return "between 3 Years and 5 Years";
  //     case "span_greater_5_Yrs":
  //       return "more than 5 Years";
  //     default:
  //       return "";
  //   }
  // };
  const openModal = (caseType, tabValue, caseTypeId) => () => {
    // const span = getSpanText(tabValue);
    // const typeText = caseType === "" ? "All Case Types" : caseType;
    // const stageText = activeStage === "all_stage" ? "All Stages" : activeStage;
    // const statusText = activeStatus === "all_status" ? "All Statuses" : activeStatus;

    // const headerString = `${typeText} Cases sorted by ${stageText}, ${statusText} with Case Age ${span}`;
    // const span = getSpanText(tabValue);
    const typeText = caseType === "" ? "All Case Types" : caseType;
    const hasFilter = currentFilter && currentFilter.name;

    const headerString = hasFilter
      ? `${typeText} cases filtered by ${currentFilter.name}, for ${tabValue}`
      : `${typeText} cases for ${tabValue}.`;

    handleShowModal({
      caseType: caseType,
      // Status: "All Statuses",
      CurrentFilter: currentFilter,
      // Stage: "All Stages",
      tabName: "County",
      tabValue: tabValue,
      headerString: headerString,
      caseTypeId: caseTypeId,
      range: tabValue,
    });
  };
  const tableRef = useRef(null);
  const aggregateRow = CaseCountiesVenueData.find((row) => !row[0]?.case_type);
  const orderedCaseRows = caseTypes.map(
    (caseType) =>
      CaseCountiesVenueData.find((row) => row[0]?.case_type === caseType.name) ||
      CountiesList.map((county) => ({
        count: 0,
        case_type: caseType.name,
        county_name: county.name,
      }))
  );
  const displayRows = aggregateRow ? [aggregateRow, ...orderedCaseRows] : orderedCaseRows;
  useEffect(() => {
    const updateHeaderMode = () => {
      const tableWidth = tableRef.current?.parentElement?.clientWidth || 0;
      const columnWidth = CountiesList.length ? tableWidth / CountiesList.length : tableWidth;
      setCountyHeaderMode(
        columnWidth >= 250 ? "full" : columnWidth >= 180 ? "compact" : "nameOnly"
      );
    };

    updateHeaderMode();
    const observer = new ResizeObserver(updateHeaderMode);
    if (tableRef.current?.parentElement) observer.observe(tableRef.current.parentElement);
    return () => observer.disconnect();
  }, [CountiesList]);
  useEffect(() => {
    const handleResize = () => setEqualColumnWidthsCounty(tableRef);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [CaseCountiesVenueData]);

  return (
    <>
      <div>
        <table
          ref={tableRef}
          className="table res_tab table-navi-different table-responsive ms-0 equal-column-width-table navigator-standard-table-header"
        >
          <tbody className=" Index-width-webkit-fill-available-display-inline-table">
            <tr className="thead">
              {CountiesList.map((county, index) => (
                <th
                  key={"th-" + index}
                  title={`${county.name} County, ${county.state?.StateAbr || ""}`}
                >
                  <div
                    className="d-flex align-items-center justify-content-center w-100"
                    style={{
                      gap: "5px",
                      minWidth: 0,
                    }}
                  >
                    <span
                      style={{
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {county.name}
                      {countyHeaderMode === "full" ? " County" : ""}
                      {countyHeaderMode !== "nameOnly" ? "," : ""}
                    </span>
                    {countyHeaderMode !== "nameOnly" && county.state?.StateAbr && (
                      <>
                        <svg
                          style={{
                            width: "15px",
                            height: "15px",
                            fill: "var(--primary-80)",
                            flexShrink: 0,
                          }}
                          className={`icon icon-state-${county.state.StateAbr}`}
                        >
                          <use xlinkHref={`#icon-state-${county.state.StateAbr}`} />
                        </svg>
                        <span style={{ flexShrink: 0 }}>{county.state.StateAbr}</span>
                      </>
                    )}
                  </div>
                </th>
              ))}
            </tr>
            {displayRows
              .filter((case_data) => case_data.length > 0)
              .map((case_data, index) => (
                <tr key={index} className="h-25px">
                  {case_data.map((individual_data, idx) =>
                    individual_data.count > 0 ? (
                      <td
                        key={"td-" + idx}
                        className="h-25px onHoverNewThings cursor-pointer text-center"
                        onClick={openModal(
                          individual_data.case_type,
                          individual_data.county_name,
                          individual_data?.case_type_id || ""
                        )}
                      >
                        <p
                          className={individual_data.count > 0 ? "fw-bold" : "text-grey"}
                          data-state-class={individual_data.county_name + "_case"}
                          // data-status-class={activeStatus}
                          // data-stage-class={activeStage}
                          data-casetype={
                            individual_data.case_type
                              ? individual_data.case_type.replace(/\s/g, "")
                              : ""
                          }
                        >
                          {individual_data.count}
                        </p>
                      </td>
                    ) : (
                      <td
                        key={"td-" + idx}
                        className="h-25px onHoverNewThings cursor-pointer text-center"
                      >
                        <p
                          className={individual_data.count > 0 ? "fw-bold" : "text-grey"}
                          data-state-class={individual_data.county_name + "_case"}
                          // data-status-class={activeStatus}
                          // data-stage-class={activeStage}
                          data-casetype={
                            individual_data.case_type
                              ? individual_data.case_type.replace(/\s/g, "")
                              : ""
                          }
                        >
                          {/* {individual_data.count} */}
                        </p>
                      </td>
                    )
                  )}
                </tr>
              ))}
            {Array.from({ length: Math.max(0, rowCount - displayRows.length + 1) }).map(
              (_, rowIndex) => (
                <tr key={`county-empty-${rowIndex}`}>
                  {Array.from({ length: CountiesList.length }).map((_, colIndex) => (
                    <td key={colIndex} className="onHoverNewThings" style={{ height: "25px" }} />
                  ))}
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CountyTab;
